export function zip<Array1, Array2>(
  firstCollection: Array1[],
  lastCollection: Array2[]
): Array<[Array1, Array2]> {
  return firstCollection.map((firstItem, index) => [firstItem, lastCollection[index]])
}
